import React from 'react'
import Alert from '../dashboard/alert'
import Address from '../shared/address'
import Welcome from '../shared/welcome.jsx'
import UpSell from '../dashboard/up-sell-card'
import NextScheduled from '../dashboard/next-scheduled-job-card'
import RepriceCard from '../dashboard/reprice-card'
import JobAwaitingApproval from '../dashboard/job-awaiting-approval'
import Zone from '../dashboard/zone-card'
import TipsCard from '../dashboard/tips-card'
import WeatherIconType from '../shared/enums/weather-icon-type'
import OrderStatus from '../dashboard/order-status-card'
import TaskProposed from '../dashboard/task-proposed-card'
import OrderCustomTasksModal from '../modals/custom-tasks-modal'
import NewTaskModal from '../modals/new-task-modal'
import JobDetailsModal from '../modals/task-details-modal'
import RepriceModal from '../modals/reprice-modal'
import OrderPaymentModal from '../modals/order-payment-modal'
import OrderConfirmationModal from '../modals/order-confirmation-modal'
import UpsellOrderModal from '../modals/order-upsell-modal'
import TaskEditModal from '../modals/task-edit-modal'
import UpgradeServiceModal from '../modals/upgrade-service-modal'
import UpgradeFrequencyModal from '../modals/upgrade-frequency-modal'
import SkipJobModal from '../modals/skip-job-modal'
import UpdateInstructionsModal from '../modals/update-instructions-modal'
import JobFinishedModal from '../modals/job-finished-modal'
import NotificationModal from '../modals/notification-modal'
import AcceptTaskModal from '../modals/accept-task-modal'
import DeclineTaskModal from '../modals/decline-task-modal'
import ProposedTaskModal from '../modals/proposed-task-modal'
import { fetchModules, fetchZoneInfo, getTipCardInformation, fetchTaskPrices, fetchAdditionalTasks } from '../api'
import { getUpSellIconType } from '../shared/enums/upsell-icon-type'
import ReactGA from 'react-ga'

let modalIcon
let numOfProposedCards = 0
let numOfRepriceCards = 0
let numOfApprovalCards = 0


export default React.createClass({
  getInitialState: function () {
    let forecastInitial = {
      iconType: WeatherIconType.CLEAR_DAY,
      summary: '...',
      temp: '0',
      maxTemp: '0',
      minTemp: '0',
      tipData: []
    }
    return {
      currentlySelectedAddressId: 0,
      forecastData: forecastInitial,
      modalCard: this.props.initialData,
      upsellCard: '',
      moduleInfo: this.props.moduleInfo || [],
      additionalTasks: [],
      showCustomTaskModal: false,
      showNewTaskModal: false,
      showJobDetailsModal: false,
      showOrderPaymentModal: false,
      showOrderConfirmationModal: false,
      showEditTaskModal: false,
      showUpgradeServiceModal: false,
      showUpgradeFrequencyModal: false,
      showUpgradeScheduleModal: false,
      showSkipJobModal: false,
      showUpdateInstructionsModal: false,
      showNotificationModal: false,
      showJobFinishedModal: false,
      showAcceptTaskModal: false,
      showRepriceModal: false,
      showDeclineTaskModal: false,
      showProposedTaskModal: false,
      notificationTitle: '',
      notificationContent: '',
      pricingArray: [],
      modalTasks: '',
      modalProps: '',
      proposedProps: '',
      taskData: '',
      comment: '',
      orderNumber: '',
      authCode: '',
      instructions: '',
      repriceCard: '',
      zoneInfo: this.props.zoneInfo || []
    }
  },
  componentDidMount: function () {
    this.refreshPage(this.props)
    getTipCardInformation().then((data) => {
      this.setState({ tipData: data })
    })
    if (this.state.pricingArray.length === 0) {
      let tempArray = []
      fetchTaskPrices('MOWLAWN', this.props.currentAddress.addressId).then((data) => {
        for (let i = 0; i < data.data.length; i++) {
          tempArray.push(data.data[i])
        }
        this.setState({ pricingArray: tempArray })
      })
    }
  },
  componentWillReceiveProps: function (nextProps) {
    this.refreshPage(nextProps)
  },
  refreshPage: function (props) {
    let address = this.props.currentAddress;
    if (props) {
      address = props.currentAddress;
    }
    if (address !== null) {
      let { addressId } = address
      if (addressId) this.setState({ currentlySelectedAddressId: addressId })
      fetchModules(addressId).then((data) => {
        this.setState({ moduleInfo: data })
      })
      fetchAdditionalTasks(addressId).then((data) => {
        this.setState({ additionalTasks: data })
      })

      fetchZoneInfo(addressId).then((data) => {
        this.setState({ zoneInfo: data })
      })
    }
  },

  routingCorrectUpsellType: function (card) {
    if (card.upSellType === 'LAWN_MOWING_NEW_TASK' || card.upSellType === 'PLOWSNOW') {
      let destination
      switch (card.upSellType) {
        case 'LAWN_MOWING_NEW_TASK':
          destination = '/showOrderNewTask/' + this.props.currentAddress.addressId + '/MOWLAWN/propertyDetails'
          ReactGA.event({
            category: 'Order New Task-Lawn Mowing',
            action: 'click',
            label: 'Order New Task'
          })
          break
        case 'PLOWSNOW':
          destination = '/showOrderNewTaskSetup?taskType=PLOWSNOW&addressId=' + this.props.currentAddress.addressId + '&baseOrderPath=showOrderNewTask&state=propertyDetails'
          ReactGA.event({
            category: 'Order New Task-Plow Snow',
            action: 'click',
            label: 'Order New Task'
          })
          break
        default:
          break
      }
      window.location.assign(window.location.origin + destination)

    }
    else if (card.upSellType === 'LAWN_MOWING_SERVICE_PACKAGE') {
      this.openUpgradeServiceModal(card.mobileTask)
    }
    else if (card.upSellType === 'LAWN_MOWING_FREQUENCY') {
      this.openUpgradeFrequencyModal(card.mobileTask)
    }
    else {
      this.openUpSellOrder(card)
    }
  },

  //Start of opening modals
  openNewTask: function () {
    ReactGA.pageview('OrderNewTaskModal');
    ReactGA.event({
      category: 'Order New Task Dashboard Button',
      action: 'click',
      label: 'Order New Task'
    })
    this.setState({ showNewTaskModal: true })
  },
  closeNewTask: function () {
    this.setState({ showNewTaskModal: false })
  },
  openTaskDetails: function (cardInfo) {
    ReactGA.pageview('JobDetailsModal');
    this.setState({ showJobDetailsModal: true, modalCard: cardInfo })
  },
  closeTaskDetails: function () {
    this.setState({ showJobDetailsModal: false })
  },
  openCustomTask: function () {
    ReactGA.pageview('CustomTaskModal');
    this.setState({ showCustomTaskModal: true, showNewTaskModal: false })
  },
  closeCustomTask: function () {
    this.setState({ showCustomTaskModal: false })
  },
  openUpSellOrder: function (cardInfo) {
    let upSellType = getUpSellIconType(cardInfo.upSellType)

    modalIcon = upSellType.iconsrc
    ReactGA.pageview('UpsellOrderModal/' + upSellType.prettify);

    this.setState({ showUpsellModal: true, upsellCard: cardInfo })
  },
  closeUpsellOrder: function () {
    this.setState({ showUpsellModal: false })
  },
  closeUpsellOpenPayment: function (modalProps, taskData, comment) {
    this.setState({ showUpsellModal: false, showProposedTaskModal: false })
    this.openOrderPayment(modalProps, taskData, comment)
  },
  openOrderPayment: function (modalProps, taskData, comment) {
    ReactGA.pageview('OrderPaymentModal');
    this.modalProps = modalProps
    this.setState({ showOrderPaymentModal: true, modalProps: modalProps, taskData: taskData, comment: comment })
  },
  closeOrderPayment: function () {
    this.setState({ showOrderPaymentModal: false })
  },
  openOrderConfirmation: function (orderNumber, price) {
    ReactGA.pageview('OrderConfirmationModal');
    ReactGA.plugin.execute('ec', 'setAction', 'purchase', {
      id: orderNumber,
      affiliation: 'CUSTOMER_NEW_TASK',
      revenue: price,
      tax: '',
      shipping: '',
      coupon: ''
    });

    ReactGA.event({
      category: 'Ordered upsell task: #' + orderNumber,
      action: 'click',
      label: 'Order Confirmation Modal'

    })

    this.setState({ showOrderConfirmationModal: true, orderNumber: orderNumber })
  },
  closeOrderConfirmation: function () {
    this.setState({ showOrderConfirmationModal: false })
    this.refreshPage();
  },
  openEditTaskModal: function (cardInfo) {
    ReactGA.pageview('EditTaskModal');
    this.setState({ showEditTaskModal: true, showJobDetailsModal: false, modalTasks: cardInfo.modalCard })
  },
  closeEditTaskModal: function () {
    this.setState({ showEditTaskModal: false })
  },
  openUpgradeServiceModal: function (task) {
    ReactGA.pageview('UpgradeServiceModal');
    if (task !== '') {
      this.setState({ showUpgradeServiceModal: true, showEditTaskModal: false, modalTasks: task })
    }
    else {
      this.setState({ showUpgradeServiceModal: true, showEditTaskModal: false })
    }
  },
  closeUpgradeServiceModal: function () {
    this.setState({ showUpgradeServiceModal: false })
    this.refreshPage();
  },
  openUpgradeFrequencyModal: function (task) {
    ReactGA.pageview('UpgradeFrequencyModal');
    if (task !== '') {
      this.setState({ showUpgradeFrequencyModal: true, showEditTaskModal: false, modalTasks: task })
    }
    else {
      this.setState({ showUpgradeFrequencyModal: true, showEditTaskModal: false })
    }
  },
  closeUpgradeFrequencyModal: function () {
    this.setState({ showUpgradeFrequencyModal: false })
    this.refreshPage();
  },
  openUpgradeScheduleModal: function () {
    ReactGA.pageview('UpgradeScheduleModal');
    this.setState({ showUpgradeScheduleModal: true, showEditTaskModal: false })
  },
  closeUpgradeScheduleModal: function () {
    this.setState({ showUpgradeScheduleModal: false })
  },
  openSkipJobModal: function () {
    ReactGA.pageview('SkipJobModal');
    this.setState({ showSkipJobModal: true, showJobDetailsModal: false })
  },
  closeSkipJobModal: function () {
    this.setState({ showSkipJobModal: false })
  },
  openUpdateInstructionsModal: function () {
    ReactGA.pageview('UpdateInstructionsModal');
    this.setState({ showUpdateInstructionsModal: true, showEditTaskModal: false })
  },
  closeUpdateInstructionsModal: function () {
    this.setState({ showUpdateInstructionsModal: false })
    this.refreshPage();
  },
  openNotificationModal: function (closingModal, notificationTitle, notificationContent) {
    ReactGA.pageview('NotificationModal');
    this.setState({ showNotificationModal: true, [closingModal]: false, notificationTitle: notificationTitle, notificationContent: notificationContent })
  },
  closeNotificationModal: function () {
    this.setState({ showNotificationModal: false })
  },
  openJobFinishedModal: function (card) {
    ReactGA.pageview('JobFinishedModal');
    this.setState({ showJobFinishedModal: true, modalCard: card })
  },
  closeJobFinishedModal: function () {
    this.setState({ showJobFinishedModal: false })
    this.refreshPage();
  },
  openAcceptTaskModal: function (authCode, instructions, card) {
    ReactGA.pageview('AcceptTaskModal');
    this.setState({ showAcceptTaskModal: true, authCode: authCode, instructions: instructions, modalCard: card })
  },
  closeAcceptTaskModal: function () {
    this.setState({ showAcceptTaskModal: false })
  },
  openDeclineTaskModal: function () {
    ReactGA.pageview('DeclineTaskModal');
    this.setState({ showDeclineTaskModal: true })
  },
  closeDeclineTaskModal: function () {
    this.setState({ showDeclineTaskModal: false })
    this.refreshPage();
  },
  openProposedTaskModal: function (cardInfo) {
    ReactGA.pageview('ProposedTaskModal');
    this.setState({ showProposedTaskModal: true, proposedProps: cardInfo, modalProps: cardInfo })
  },
  closeProposedTaskModal: function () {
    this.setState({ showProposedTaskModal: false })
  },
  openRepriceModal: function (card) {
    ReactGA.pageview('RepriceModal');
    this.setState({ showRepriceModal: true, repriceCard: card })
  },
  closeRepriceModal: function () {
    this.setState({ showRepriceModal: false })
    this.refreshPage();
  },
  //End of Opening Modals

  render: function () {
    numOfProposedCards = 0
    numOfRepriceCards = 0
    numOfApprovalCards = 0

    if (!this.props.loginData) {
      return (<div />)
    }
    let addressIndex = 0
    let loginData = this.props.loginData
    let name = ''
    if (loginData && loginData.customer) {
      name = loginData.customer.name
    }
    let customerAddresses = []
    for (let i = 0; i < loginData.customer.addresses.length; i++) {
      let addressData = loginData.customer.addresses[i]
      let customerAddress = addressData.streetAddress + ', ' + addressData.city
      customerAddresses.push(customerAddress)
    }

    let alertArray = []
    let upsellArray = []
    let taskProposedArray = []
    let repriceArray = []
    let orderStatusArray = []
    let jobAwaitingApprovalArray = []
    let nextScheduleJobArray = []
    let largeAdditionalTasksArray = []
    let yardCareZoneCard = null
    let zoneNum = loginData.customer.addresses[addressIndex].seasonalityZone
    let isFirstLeft = true
    let isFirstRight = true
    let unorderedModuleSpacing = false

    if (this.state.moduleInfo && this.state.moduleInfo.length !== 0) {
      for (let card of this.state.moduleInfo) {
        switch (card.moduleType) {
          case 'ORDER_STATUS':
            break
          case 'REPRICE_REQUESTED':
            unorderedModuleSpacing = true
            isFirstLeft = false
            break
          default:
            break
        }
      }
      for (let card of this.state.moduleInfo) {
        switch (card.moduleType) {
          case 'UP_SELL':
            upsellArray.push(<UpSell address={this.props.currentAddress.addressId} noPullDown={isFirstRight} key={card.moduleId} card={card} openModal={() => this.routingCorrectUpsellType(card)} login={loginData} />)
            isFirstRight = false
            break
          case 'TASK_PROPOSED':
            taskProposedArray.push(<TaskProposed noPullDown={isFirstRight} key={card.moduleId} card={card} btnOnClick={() => this.openProposedTaskModal(card)} numOfProposedCards={numOfProposedCards} />)
            numOfProposedCards++;
            isFirstRight = false
            break
          case 'ORDER_STATUS':
            orderStatusArray.push(<OrderStatus noPullDown={isFirstLeft} key={card.moduleId} card={card} />)
            unorderedModuleSpacing = false
            isFirstLeft = false
            break
          case 'JOB_AWAITING_APPROVAL':
            if (card.mobileJob.workFlowStep !== 'CUSTOMER_REJECTS') {
              jobAwaitingApprovalArray.push(<JobAwaitingApproval noPullDown={isFirstLeft} key={card.moduleId} card={card} btnOnClick={() => this.openJobFinishedModal(card)} numOfApprovalCards={numOfApprovalCards} />)
              isFirstLeft = false
            }
            break
          case 'NEXT_SCHEDULE_JOB':
            if (card.content) {
              card.content = card.content.replace('basic', 'budget')
            }

            if (card.workFlowStep === 'OFFSEASON') {
              nextScheduleJobArray.push(<NextScheduled noPullDown={isFirstLeft} key={card.moduleId} card={card} btnOnClick={() => { }} hideBtnOnClick={true} />)
            } else {
              nextScheduleJobArray.push(<NextScheduled noPullDown={isFirstLeft} key={card.moduleId} card={card} btnOnClick={() => this.openTaskDetails(card)} />)
            }
            isFirstLeft = false
            break
          case 'ALERT':
            alertArray.push(<Alert key={card.moduleId} title={card.header} text={card.content} linkText='UPDATE NOW' link={window.location.origin + '/#/billing'} />)
            unorderedModuleSpacing = false
            isFirstLeft = false
            isFirstRight = false
            break
          case 'REPRICE_REQUESTED':
            repriceArray.push(<RepriceCard noPullDown={unorderedModuleSpacing} card={card} key={card.moduleId} btnOnClick={() => this.openRepriceModal(card)} numOfRepriceCards={numOfRepriceCards} />)
            unorderedModuleSpacing = false
            isFirstLeft = false
            break
          default:
            console.log('Great Scott! A weird module type! ')
            break
        }
      }
    }

    let keyCounter = 1
    for (let card of this.state.additionalTasks) {
      if (card.upSellType !== null) {
        largeAdditionalTasksArray.push(<div key={keyCounter} className='col-sm-4 upsell-trio'>
          <UpSell address={this.props.currentAddress.addressId} login={loginData} btnId={keyCounter} card={card} openModal={() => this.routingCorrectUpsellType(card)} index={keyCounter} />
        </div>)
      }
      else {
        console.log('No upsell types were found.')
      }
      keyCounter++
    }

    if (this.state.zoneInfo && this.state.zoneInfo.length !== 0) {
      yardCareZoneCard = <Zone data={this.state.zoneInfo} zoneNum={zoneNum} />
    }

    let leftStack = [...jobAwaitingApprovalArray, ...repriceArray, ...orderStatusArray, ...nextScheduleJobArray]
    let rightStack = [...taskProposedArray, ...upsellArray]

    return (

      <div>
        <JobDetailsModal
          show={this.state.showJobDetailsModal}
          hide={this.closeTaskDetails}
          modalCard={this.state.modalCard ? this.state.modalCard.mobileJob : null}
          description={this.state.modalCard ? this.state.modalCard.content : null}
          showEditTask={this.openEditTaskModal}
          showSkipJob={this.openSkipJobModal} />
        <OrderCustomTasksModal
          modalHeader='Order Custom Task'
          modalSubHeader="Please describe the task you're interested in having performed in as much detail as possible."
          show={this.state.showCustomTaskModal}
          hide={this.closeCustomTask}
          address={this.props.currentAddress.addressId} />
        <NewTaskModal
          modalHeader='Order New Task'
          modalSubHeader='What kind of task are you looking for?'
          show={this.state.showNewTaskModal}
          hide={this.closeNewTask}
          openCustom={this.openCustomTask}
          openUpsellModal={this.openUpSellOrder}
          login={this.props.loginData}
          addressId={this.state.currentlySelectedAddressId} />
        <OrderPaymentModal
          login={this.props.loginData}
          modalProps={this.state.modalProps}
          comment={this.state.comment}
          taskData={this.state.taskData}
          show={this.state.showOrderPaymentModal}
          hide={this.closeOrderPayment}
          openConfirmation={this.openOrderConfirmation}
          openNotificationModal={this.openNotificationModal} />
        <OrderConfirmationModal
          login={this.props.loginData}
          show={this.state.showOrderConfirmationModal}
          hide={this.closeOrderConfirmation}
          orderNumber={this.state.orderNumber}
          modalProps={this.state.modalProps}
          taskData={this.state.taskData} />
        <UpsellOrderModal
          address={this.props.currentAddress.addressId}
          streetAddress={this.props.currentAddress.streetAddress}
          icon={modalIcon}
          card={this.state.upsellCard}
          login={this.props.loginData}
          show={this.state.showUpsellModal}
          hide={this.closeUpsellOrder}
          openPayment={this.closeUpsellOpenPayment} />
        <RepriceModal
          show={this.state.showRepriceModal}
          hide={this.closeRepriceModal}
          repriceCard={this.state.repriceCard}
          openNotificationModal={this.openNotificationModal} />
        <TaskEditModal
          task={this.state.modalTasks}
          addressId={this.props.currentAddress.addressId}
          show={this.state.showEditTaskModal}
          hide={this.closeEditTaskModal}
          openUpgradeServiceModal={this.openUpgradeServiceModal}
          openUpgradeFrequencyModal={this.openUpgradeFrequencyModal}
          openUpgradeScheduleModal={this.openUpgradeScheduleModal}
          openUpdateInstructionsModal={this.openUpdateInstructionsModal}
          fullComponent={true} />
        <UpgradeServiceModal
          show={this.state.showUpgradeServiceModal}
          hide={this.closeUpgradeServiceModal}
          task={this.state.modalTasks}
          addressId={this.state.currentlySelectedAddressId}
          openNotificationModal={this.openNotificationModal}
          pricingArray={this.state.pricingArray} />
        <UpgradeFrequencyModal
          show={this.state.showUpgradeFrequencyModal}
          hide={this.closeUpgradeFrequencyModal}
          task={this.state.modalTasks}
          openNotificationModal={this.openNotificationModal}
          pricingArray={this.state.pricingArray} />
        <SkipJobModal
          show={this.state.showSkipJobModal}
          hide={this.closeSkipJobModal}
          modalCard={this.state.modalCard}
          openNotificationModal={this.openNotificationModal} />
        <UpdateInstructionsModal
          show={this.state.showUpdateInstructionsModal}
          hide={this.closeUpdateInstructionsModal}
          modalCard={this.state.modalCard}
          openNotificationModal={this.openNotificationModal} />
        <NotificationModal
          hide={this.closeNotificationModal}
          show={this.state.showNotificationModal}
          title={this.state.notificationTitle}
          content={this.state.notificationContent} />
        <JobFinishedModal
          show={this.state.showJobFinishedModal}
          hide={this.closeJobFinishedModal}
          modalCard={this.state.modalCard}
          login={this.props.loginData}
          addressId={this.state.currentlySelectedAddressId}
          openAcceptTaskModal={this.openAcceptTaskModal}
          openDeclineTaskModal={this.openDeclineTaskModal}
          openNotificationModal={this.openNotificationModal} />
        <AcceptTaskModal
          show={this.state.showAcceptTaskModal}
          hide={this.closeAcceptTaskModal}
          authCode={this.state.authCode}
          modalCard={this.state.modalCard ? this.state.modalCard : null}
          instructions={this.state.instructions}
          openNotificationModal={this.openNotificationModal} />
        <DeclineTaskModal
          show={this.state.showDeclineTaskModal}
          hide={this.closeDeclineTaskModal}
          goBack={this.openJobFinishedModal}
          modalCard={this.state.modalCard ? this.state.modalCard : null}
          openNotificationModal={this.openNotificationModal} />
        <ProposedTaskModal
          address={this.props.currentAddress.addressId}
          streetAddress={this.props.currentAddress.streetAddress}
          openNotificationModal={this.openNotificationModal}
          show={this.state.showProposedTaskModal}
          hide={this.closeProposedTaskModal}
          modalCard={this.state.proposedProps}
          openPayment={this.closeUpsellOpenPayment}
          proposed={true} />

        <div className='concrete-gray-background' style={{ paddingBottom: 40 }}>
          <div className='container-cards'>
            <div className='row'>
              <div className='col-xs-12 history-wrap'>
                <div className='row pull-down-sm-1'>
                  <div className='col-sm-5 col-xs-12'>
                    <Welcome name={name} />
                  </div>
                  <div className='col-sm-7 col-xs-12 text-right address'>
                    <Address addresses={customerAddresses} curIndex={this.props.curAddressIndex} onChange={this.props.reportAddressChange} />
                  </div>
                </div>
              </div>
            </div>
            <div className='row pull-down-sm-1'>
              <div className='col-xs-6'>
              </div>
              <div className='col-xs-6 pull-right'>
                <button id="orderNewTaskButton" type='button' className='btn btn-sm btn-success pull-right' onClick={this.openNewTask} style={{ minWidth: 10 + 'em', maxWidth: 15 + 'em', width: '60%' }}>
                  + Order New Task
                </button>
              </div>
            </div>
            <div className='row pull-down-xs-1'>
              <div className='col-xs-12'>
                {alertArray}
              </div>
            </div>
            <div className='row'>
              <div className='col-sm-6'>
                {leftStack}
              </div>
              <div className='col-sm-6 hidden-xs'>
                {rightStack}
              </div>
              <div className='col-sm-6 pull-down-xs-3 visible-xs'>
                {rightStack}
              </div>
            </div>
          </div>
        </div>
        <div className='white-background' style={{ paddingTop: 40, paddingBottom: 40, minHeight: 750 }} id='seasonalTaskBlock'>
          <div className='container-cards'>
            <h5>Additional Tasks For Your Yard</h5>
            <p style={{ marginBottom: '0px' }}>Our number one goal is to keep your yard looking healthy and beautiful. We are offering the following one-time tasks for your yard to keep it in tip-top shape.</p>
            <div className='row'>
              {largeAdditionalTasksArray}
            </div>
          </div>
        </div>
        <div className='concrete-gray-background' style={{ paddingTop: 20, paddingBottom: 20 }}>
          <div className='container-cards'>
            <div className='row'>
              <div className='col-sm-6'>
                {yardCareZoneCard}
              </div>
              <div className='col-sm-6'>
                <TipsCard data={this.state.tipData} />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
})



// WEBPACK FOOTER //
// ./src/components/dashboard/dashboard.jsx